import axios from "@/plugins/axios";

let url = "/api/v1/common/partners";

export const partners = {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};
